module.exports = __webpack_public_path__ + "static/img/list-item-4.f999091.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/list-item-4.png
// module id = rdk4
// module chunks = 1